import { Box } from '@mui/material';
import { useRef } from 'react';

interface Props {
  children?: React.ReactElement<unknown>;
  height?: string,
  padding?: string,
  color?: 'light' | 'dark'
  backgroundImage?: string
  isBackgroundCover?: boolean
}

export default function Section(props: Props) {
  const targetRef = useRef<HTMLDivElement>(null)
  return (
    <Box component={'section'} sx={(theme) => {
      return (
        {
          [theme.breakpoints.up('xs')]: {
            minHeight: props.height || 'auto',
            padding: props.padding || '0.5rem 0 0.5rem 0',
          },
          [theme.breakpoints.up('sm')]: {
            minHeight: props.height || 'auto',
            padding: props.padding || '1rem 0 1rem 0',
          },
          [theme.breakpoints.up('md')]: {
            minHeight: props.height || 'auto',
            padding: props.padding || '2rem 0 2rem 0',
          },
          [theme.breakpoints.up('lg')]: {
            minHeight: props.height || 'auto',
            padding: props.padding || '3rem 0 3rem 0 ',
          },
          marginBottom: 'auto',
          position: 'relative',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: theme.palette.grey[props.color === 'light' ? 900 : 50],
          backgroundColor: theme.palette.grey[props.color === 'light' ? 50 : 900],
          backgroundImage: props?.backgroundImage || '',
          backgroundAttachment: props.isBackgroundCover ? 'fixed' : 'scroll',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }
      )
    }
    }>
      <Box ref={targetRef} sx={{
        width: '100%',
        zIndex: 1
      }}>
        {props.children}
      </Box>
      {props.backgroundImage
        &&
        <Box sx={(theme) => {
          return (
            {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: theme.palette.grey[900],
              opacity: '0.7'
            }
          )
        }}>
        </Box>
      }
    </Box >
  );
}